<ng-template #step1>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.RemovePort.Subheading" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.RemovePort.Text" | translate }}</p>
    </div>
    <div>
      @for (item of mappedPorts(); track $index; let i = $index) {
        <div>
          @if (item.endpoints && item.endpoints.length === 1) {
            <div class="selfservice-add-port__bar">
              <div class="selfservice-add-port__left">
                <div class="selfservice-add-port__details" [class.active]="item.selected">
                  <div class="selfservice-add-port__icon-box">
                    <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                  </div>
                  <div>
                    <h3>{{ item.endpoints[0].port?.customerDescription }}</h3>
                    <div class="selfservice-add-port__meta">
                      {{ item.endpoints[0].port?.subscriptionId | shorten_guid }} -
                      {{ item.endpoints[0].port?.customer?.fullname }}, {{ item.endpoints[0].port?.address?.city }} ({{
                        item.endpoints[0].port?.address?.street
                      }}), VLAN {{ item.endpoints[0].vlanrange }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="selfservice-add-port__right">
                @if (isMyPort(item.endpoints[0].port)) {
                  <div class="selfservice-add-port__toggle">
                    <input [id]="'toggle-' + i" type="checkbox" [checked]="item.selected" (change)="toggleESI(i)" />
                    <label [for]="'toggle-' + i">
                      <selfservice-toggle [active]="item.selected"></selfservice-toggle>
                    </label>
                  </div>
                } @else {
                  <div>
                    <div class="selfservice-add-port__no-access">
                      <svg-icon src="assets/images/icons/lock.svg"></svg-icon>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (item.endpoints && item.endpoints.length > 1) {
            <div class="selfservice-add-port__bar selfservice-add-port__bar--col">
              <div class="selfservice-add-port__bar-flex">
                <div class="selfservice-add-port__details" [class.active]="item.selected">
                  <div class="selfservice-add-port__icon-box">
                    <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                  </div>
                  <div>
                    <h3>{{ "Selfservice.MulthomedInterface" | translate }}</h3>
                    <div class="selfservice-add-port__meta">
                      {{ item.endpoints[0].port?.customer?.fullname }}, VLAN {{ item.endpoints[0].vlanrange }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selfservice-add-port__toggle">
                    <input [id]="'toggle-' + i" type="checkbox" [checked]="item.selected" (change)="toggleESI(i)" />
                    <label [for]="'toggle-' + i">
                      <selfservice-toggle [active]="item.selected"></selfservice-toggle>
                    </label>
                  </div>
                </div>
              </div>
              <ul class="selfservice-add-port__list">
                @for (subitem of item.endpoints; track $index) {
                  <li
                    class="selfservice-add-port__list-item"
                    [class.selfservice-add-port__list-item--purple]="item.selected"
                  >
                    <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                    <div>
                      <div class="selfservice-add-port__list-title">{{ subitem.port?.customerDescription }}</div>
                      {{ subitem.port?.subscriptionId | shorten_guid }} - {{ subitem.port?.customer?.fullname }},
                      {{ subitem.port?.address?.city }} ({{ subitem.port?.address?.street }}), VLAN
                      {{ subitem.vlanrange }},
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #step2>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Global.Summary" | translate }}</h3>
      <p class="no-margin t-newline">{{ "Selfservice.RemovePort.SummaryText" | translate }}</p>
    </div>

    <div class="selfservice-add-port__summary">
      <div class="selfservice-add-port__summary-item">
        <div class="selfservice-add-port__summary-top" (click)="toggleSummaryItemOne()">
          <div class="selfservice-add-port__summary-top-left">{{ "Selfservice.AddPort.RemovedPorts" | translate }}</div>
          <div class="selfservice-add-port__summary-top-right">
            <div>{{ "Selfservice.IPP.Total" | translate }}</div>
            <div>{{ removedPorts().length }}</div>
            <svg-icon src="assets/images/icons/chevron-down.svg" [class.active]="summaryItemOneExpanded()"> </svg-icon>
          </div>
        </div>
        @if (summaryItemOneExpanded()) {
          <div class="selfservice-add-port__summary-expand">
            <ul class="selfservice-add-port__list">
              @for (item of removedPorts(); track $index) {
                <li class="selfservice-add-port__list-item selfservice-add-port__list-item--red">
                  <svg-icon src="assets/images/icons/x.svg"></svg-icon>
                  @if (item.endpoints) {
                    <div>
                      @if (item.endpoints.length === 1) {
                        <div class="selfservice-add-port__list-title">
                          {{ item.endpoints[0].port?.customerDescription }}
                        </div>
                      } @else {
                        <div class="selfservice-add-port__list-title">
                          {{ "Selfservice.MulthomedInterface" | translate }}
                        </div>
                      }
                      <div>
                        {{ item.endpoints[0].port?.subscriptionId | shorten_guid }} -
                        {{ item.endpoints[0].port?.customer?.fullname }},
                        {{ item.endpoints[0].port?.address?.city }} ({{ item.endpoints[0].port?.address?.street }}),
                        VLAN {{ item.endpoints[0].vlanrange }}
                      </div>
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <div class="selfservice-add-port__summary">
      <div class="selfservice-add-port__summary-item">
        <div class="selfservice-add-port__summary-top" (click)="toggleSummaryItemTwo()">
          <div class="selfservice-add-port__summary-top-left">
            {{ "Selfservice.AddPort.AlreadyLinkedPorts" | translate }}
          </div>
          <div class="selfservice-add-port__summary-top-right">
            <div>{{ "Selfservice.IPP.Total" | translate }}</div>
            <div>{{ existingPorts().length }}</div>
            <svg-icon src="assets/images/icons/chevron-down.svg" [class.active]="summaryItemTwoExpanded()"> </svg-icon>
          </div>
        </div>

        @if (summaryItemTwoExpanded()) {
          <div class="selfservice-add-port__summary-expand">
            <ul class="selfservice-add-port__list">
              @for (item of existingPorts(); track $index) {
                <li class="selfservice-add-port__list-item selfservice-add-port__list-item--purple">
                  @if (item.endpoints && item.endpoints.length === 1) {
                    <div class="selfservice-add-port__list-item-inner">
                      <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                      <div>
                        <div class="selfservice-add-port__list-title">
                          {{ item.endpoints[0].port?.customerDescription }}
                        </div>
                        <div>
                          {{ item.endpoints[0].port?.subscriptionId | shorten_guid }} -
                          {{ item.endpoints[0].port?.customer?.fullname }},
                          {{ item.endpoints[0].port?.address?.city }} ({{ item.endpoints[0].port?.address?.street }}),
                          VLAN {{ item.endpoints[0].vlanrange }}
                        </div>
                      </div>
                    </div>
                  }
                  @if (item.endpoints && item.endpoints.length > 1) {
                    <div class="selfservice-add-port__list-item-multihome">
                      <div class="selfservice-add-port__list-item-multihome-title">
                        {{ "Selfservice.MulthomedInterface" | translate }}
                      </div>
                      @for (subitem of item.endpoints; track $index) {
                        <div class="selfservice-add-port__list-item-inner">
                          <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                          <div>
                            <div class="selfservice-add-port__list-title">{{ subitem.port?.description }}</div>
                            <div>
                              {{ subitem.port?.subscriptionId | shorten_guid }} -
                              {{ subitem.port?.customer?.fullname }}, {{ subitem.port?.address?.city }} ({{
                                subitem.port?.address?.street
                              }}), VLAN
                              {{ subitem.vlanrange }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="dialog__bottom-message">
    <div class="dialog__bottom-message-inner">
      <svg-icon src="assets/images/icons/status-failure.svg" class="dialog__bottom-message-icon"></svg-icon>
      <span>{{ "Selfservice.RemovePort.Message" | translate }} </span>
    </div>
  </div>
</ng-template>

<selfservice-wizard
  [steps]="[step1, step2]"
  [getCommand]="buildCommand"
  [bus]="bus()"
  [canContinue]="!disableSubmitButton()"
/>
